import type { IAiAgentRepository } from "@/application/ports/repositories/IAiAgentRepository";
import type { AgentFeedbackRequest, AgentQueryResponse } from "@/domain/aiAgent";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class AiAgentRepository implements IAiAgentRepository {
  async submitFeedback(request: AgentFeedbackRequest): Promise<void> {
    await unwrap(sdk.submitFeedback({ body: request }));
  }

  async sendQuery(
    question: string,
    sessionId?: string,
    signal?: AbortSignal,
  ): Promise<AgentQueryResponse> {
    signal?.throwIfAborted();
    return unwrap(sdk.queryAgent({ body: { question, session_id: sessionId }, signal }));
  }
}
